// For dev and staging environment, we can add parameter on url
// disableCrossDevice=true
// if present, onfido will disable programmatically the cross device uploads

import { StepDefinition } from "onfido-sdk-ui/types/shared/Types";
import { ENVIRONMENTS } from "../../../utils";

// this additional feature help testers when try and test onfido flow
type ToggleCrossDeviceSteps = (
  steps: Array<StepDefinition>,
  queryParams: URLSearchParams,
) => Array<StepDefinition>;

export const toggleCrossDeviceSteps: ToggleCrossDeviceSteps = (
  steps,
  queryParams,
) => {
  const isProduction = window.getEnv() === ENVIRONMENTS.PRODUCTION;
  const disableCrossDevice = queryParams.get("disableCrossDevice");

  if (disableCrossDevice && !isProduction) {
    return steps.map(item => {
      const { type, options } = item;
      if (type === "document") {
        return {
          ...item,
          options: {
            ...(options || {}),
            forceCrossDevice: false,
          },
        };
      } else {
        return item;
      }
    });
  }
  return steps;
};
